import { render } from "./achieve.vue?vue&type=template&id=0186f8b6&scoped=true"
import script from "./achieve.vue?vue&type=script&lang=js"
export * from "./achieve.vue?vue&type=script&lang=js"

import "./achieve.vue?vue&type=style&index=0&id=0186f8b6&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0186f8b6"]])

export default __exports__